import React, { useState, useEffect } from 'react';
import axios from '../../../axios';
import Header from '../../Header';
import styles from './FilterManager.module.css';

function FilterManager() {
    const [filters, setFilters] = useState([]);
    const [category, setCategory] = useState('stone');
    const [value, setValue] = useState('');

    useEffect(() => {
        fetchFilters();
    }, []);

    const fetchFilters = () => {
        axios.get('/filters').then(({ data }) => {
            setFilters(data);
        }).catch((err) => {
            console.error(err);
            alert("Помилка при завантаженні фільтрів");
        });
    };

    const handleCreate = (e) => {
        e.preventDefault();
        if (!value) return;

        axios.post('/filters', { category, value }).then(() => {
            setValue('');
            fetchFilters();
            alert("Фільтр створено");
        }).catch((err) => {
            console.error(err);
            alert("Помилка при створенні фільтру");
        });
    };

    const handleRemove = (id) => {
        if(window.confirm("Видалити цей фільтр?")) {
            axios.delete(`/filters/${id}`).then(() => {
                fetchFilters();
            }).catch((err) => {
                console.error(err);
                alert("Помилка при видаленні фільтру");
            });
        }
    };

    return (
        <>
            <Header />
            <div className={styles.wrapper}>
                <div className={styles.content}>
                    <h2>Керування фільтрами</h2>
                    <form onSubmit={handleCreate} className={styles.form}>
                        <div className={styles.item}>
                            <label>Категорія:</label>
                            <select value={category} onChange={(e) => setCategory(e.target.value)} className={styles.input}>
                                <option value="stone">Вставки (каміння)</option>
                                <option value="cut">Огранювання</option>
                                <option value="metal">Метал</option>
                            </select>
                        </div>
                        <div className={styles.item}>
                            <label>Значення:</label>
                            <input 
                                type="text" 
                                value={value} 
                                onChange={(e) => setValue(e.target.value)} 
                                placeholder="Наприклад: Золото" 
                                className={styles.input}
                            />
                        </div>
                        <button type="submit" className={styles.button}>Додати фільтр</button>
                    </form>

                    <div className={styles.list}>
                        <h3>Існуючі фільтри</h3>
                        {['stone', 'cut', 'metal'].map(cat => (
                            <div key={cat} className={styles.categoryBlock}>
                                <h4>{cat === 'stone' ? 'Вставки (каміння)' : cat === 'cut' ? 'Огранювання' : 'Метал'}</h4>
                                <ul>
                                    {filters.filter(f => f.category === cat).map(f => (
                                        <li key={f._id} className={styles.listItem}>
                                            <span>{f.value}</span>
                                            <button onClick={() => handleRemove(f._id)} className={styles.removeBtn}>Видалити</button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}

export default FilterManager;
